import store from '@polleverywhere/redux'
import { slice, LoadingState } from '@polleverywhere/redux/slices/participant_response_history'

const PAGE_BASE = 'response_history'

export function pathDataFromState () {
  const state = store.getState()[slice.name]
  if (state.loading !== LoadingState.done) return
  return {
    page: state?.meta?.current_page || 1,
    presenter: state?.presenter || false,
    detail: state?.focus?.id || false
  }
}

export function pathDataToUrl (pathData) {
  if (pathData.detail) {
    return `${PAGE_BASE}/${pathData.detail}`
  }

  const parts = []

  if (pathData.presenter) {
    parts.push(`presenter=${pathData.presenter}`)
  }
  if (pathData.page > 1) {
    parts.push(`page=${pathData.page}`)
  }

  if (parts.length) {
    return `${PAGE_BASE}?${parts.join('&')}`
  }

  return PAGE_BASE
}

export function fragmentToPathData (fragment) {
  const match = /^response_history(?:\/(\d+))?\??(?:presenter=([A-Za-z0-9]+))?&?(?:page=(\d+))?/.exec(fragment)
  if (match) {
    const [, detail, presenter, page] = match
    return {
      detail: detail || false,
      presenter: presenter || false,
      page: parseInt(page, 10) || 1
    }
  }
}
